import { html } from "htm/preact";

import type * as Bible from "../modules/bible";

import { BibleContentVerse } from "./BibleContentVerse";

export const BibleContentTable = ({ table }: { table: Bible.ContentTable }) => {
  return html`<div class="BibleContentParagraph--table">
    <table class="BibleContentTable">
      ${table.rows.map((row) => {
        return html`<tr key=${row.key}>
          ${row.cells.map((cell, index) => {
            const tag = cell.isHeader ? "th" : "td";
            const verse =
              index === 0 && row.verse
                ? html`<${BibleContentVerse} verse=${row.verse} />`
                : null;
            return html`
              <${tag} data-align=${cell.align} key=${cell.key}>
                ${verse}
                ${cell.items.map((item) => {
                  return html`<span
                    data-style=${item.styleAttribute}
                    key=${item.key}
                    >${item.content}</span
                  >`;
                })}
              </${tag}>
            `;
          })}
        </tr>`;
      })}
    </table>
  </div>`;
};
